import { Campus, Maybe } from 'content-service'

const validateDefaultCampusProps = (defaultCampus: Campus | null) => {
  return {
    address: defaultCampus?.address || '',
    phoneNumber: defaultCampus?.phone || '',
    name: defaultCampus?.name || '',
    city: defaultCampus?.city || '',
  }
}

const collateCampusNames = (campuses: Maybe<Maybe<Campus>[]> | undefined): string => {
  const campusNames: string[] = []

  if (!campuses) {
    return ''
  }

  for (const item of campuses) {
    if (item?.name) {
      campusNames.push(item.name)
    }
  }

  return campusNames.join(', ')
}

export { validateDefaultCampusProps, collateCampusNames }
